import React, { useEffect, useRef, useState } from "react";
import { useField } from "@unform/core";
import MuiPhoneNumber from "material-ui-phone-number";
import { FormControl, FormHelperText } from "@material-ui/core";

interface Props {
  name: string;
  label: string;
  disabled?: boolean;
  defaultValue?: string;
}

const PhoneInputField: React.FC<Props> = ({
  name,
  label,
  disabled,
  defaultValue: propDefaultValue
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, defaultValue: fieldDefaultValue = "", error } = useField(name);
  const [value, setValue] = useState(propDefaultValue || fieldDefaultValue);

  useEffect(() => {
    registerField<string>({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => value,
      setValue: (_, val) => setValue(val),
      clearValue: () => setValue("")
    });
  }, [fieldName, registerField, value]);

  return (
    <FormControl fullWidth margin="dense" error={!!error}>
      <MuiPhoneNumber
        id={fieldName}
        name={fieldName}
        label={label}
        defaultCountry="br"
        value={value}
        onChange={(val) => setValue(val)}
        disableAreaCodes
        countryCodeEditable={false}
        variant="outlined"
        inputProps={{ ref: inputRef }}
        onlyCountries={["br", "us", "py", "es", "ar", "uy", "cl", "bo", "pe", "ec", "ve", "pt"]}
        disabled={disabled}
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default PhoneInputField;
